/**
 * Thin wrapper around GA4's gtag() and Meta Pixel fbq(). Only fires in production
 * (both are excluded on localhost via index.html).
 */

declare function gtag(command: 'event', eventName: string, params?: Record<string, unknown>): void;
declare function fbq(command: string, eventName: string, params?: Record<string, unknown>): void;

export function hasAnalyticsConsent(): boolean {
  try {
    const match = document.cookie.match('(^| )wedsy_cookie_consent=([^;]+)');
    return !!match && match[2] === 'accepted';
  } catch {
    return false;
  }
}

export function track(eventName: string, params?: Record<string, unknown>) {
  if (!hasAnalyticsConsent()) return;
  try {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, params);
    }
  } catch {
    // Silently ignore — analytics must never break the app
  }
}

/**
 * Fire a Meta Pixel standard event. Only fires when pixel is loaded (production + consent).
 * Pass eventID when you also fire the same event server-side via CAPI (for deduplication).
 */
export function trackMeta(
  eventName: 'Lead' | 'Purchase' | 'ViewContent' | 'PageView',
  params?: Record<string, unknown>,
  eventID?: string,
) {
  try {
    if (typeof fbq !== 'undefined') {
      fbq('track', eventName, params ? { ...params, ...(eventID ? { eventID } : {}) } : (eventID ? { eventID } : {}));
    }
  } catch {
    // Silently ignore
  }
}
